import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import Configuration from "../Configuration";
import { getAppInsights } from "./appInsightsInstance";

export function createAzureAppIPlugin() {
    const azureAppIPlugin = new ReactPlugin();
    const CONNECTION_STRING = Configuration.get("azureAppIConnectionString");
    const appInsights = new ApplicationInsights({
        config: {
            connectionString: CONNECTION_STRING,
            enableAutoRouteTracking: true,
            disableCookiesUsage: true,
            extensions: [azureAppIPlugin],
            extensionConfig: {
                [azureAppIPlugin.identifier]: {},
            },
        },
    });
    appInsights.loadAppInsights();
    return { azureAppIPlugin, appInsights };
}

export function trackEvent(event: {
    name: string;
    properties?: Record<string, string | number | boolean>;
}) {
    const appInsights = getAppInsights();
    if (appInsights) {
        appInsights.trackEvent({ name: event.name }, event.properties);
    }
}

export function trackPageView(event: { name: string }) {
    const appInsights = getAppInsights();
    if (appInsights) {
        appInsights.trackPageView({ name: event.name });
    }
}
